<template>
  <v-card>
    <v-tabs v-model="tab" background-color="primary" grow dark>
      <v-tabs-slider></v-tabs-slider>
      <v-tab v-for="tab in tabsList" :key="tab.to" :to="tab.to">
        <v-icon color="white" class="mr-1">{{ tab.icon }}</v-icon>{{ tab.name }}
      </v-tab>
    </v-tabs>
    <router-view></router-view>
  </v-card>
</template>
<script>
export default {
  data () {
    return {
      tab: null
    }
  },
  computed: {
    tabsList () {
      return [{
        name: this.$t('message.warehouse.stock'),
        to: '/w_h/stocks',
        icon: 'mdi-store'
      }, {
        name: this.$t('message.warehouse.order'),
        to: '/w_h/order',
        icon: 'mdi-cart-plus'
      }, {
        name: this.$t('message.warehouse.ccsheet'),
        to: '/w_h/ccsheet',
        icon: 'mdi-format-list-checks'
      }, {
        name: this.$t('message.warehouse.product'),
        to: '/w_h/products',
        icon: 'mdi-semantic-web'
      }]
    }
  },
  watch: {
    '$route.name' (val) {
      if (!val) this.$router.go(-1)
    },
    tab (val) {
      var getTab = this.tabsList.find(x => x.to === val)
      if (getTab) {
        document.title = `Lager/${getTab.name}`
      }
    }
  },
  mounted () {
    if (!this.$route.name) this.$router.push('/w_h/stocks')
  }
}
</script>
